/**
 * @file collegeActivity.js
 * @author Geoffrey Pursell
 * @desc PostGradIndicators report plugin

*/

/**
 * @module collegeActivity 
 * @desc PostGradIndicators report plugin
 */

define('plugins/collegeGraduates',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util", "models",
        "text!plugins/templates/collegeGraduates_newEnrollmentByRace_table.html!strip", "text!plugins/templates/collegeGraduates_newEnrollmentByAge_table.html!strip", "text!plugins/templates/collegeGraduates_newEnrollmentByGender_table.html!strip", "text!plugins/templates/collegeGraduates_topTenMajors_table.html!strip", "text!plugins/templates/collegeGraduates_programOfStudy_table.html!strip", "cardboard/pluginPieces"],
       function (_,
                  CardboardModels, CardboardCollections, Util, SLEDSModels,
                  newEnrollmentByRace, newEnrollmentByAge, newEnrollmentByGender, topTenMajorsTemplate, programOfStudyTemplate, PluginPieces) {

    console.log("MODULE: collegeGraduates");

    var exports = {

        // options for the demo cats config. since this is a multi-select
        // report, we have to use a different view object, and tell it not to
        // show grades as categories.
        options: {
            orgDetailPane: false,
            noMapSearch: true,
            forcedSummaryFilters: ["collegeGraduatesCOHORTID"],
            definitions: true
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "New Awards by Race/Ethnicity",
                explanationText: 'This report shows the number and percent of graduates by race/ethnicity. Prior to 2010, race/ethnicity data was collected using the 5 federal race categories. After 2010, race/ethnicity data was collected using the 9 federal race categories for college students. Please see race/ethnicity in the data dictionary for more information. "Unavailable" means the student did not report their race/ethnicity to the college. This data includes all public and private postsecondary institutions in Minnesota, including Walden University and Capella University (2 large private postsecondary institutions offering programs online and mainly enrolling non-Minnesota resident students in graduate-level programs). ',
                openByDefault: true,
                views: [
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "collegeGraduatesByEthnicity.data[0].slice",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        //  convertDataHashToArray: true,
                        dataDimensions: 2,
                        xAxisLabelPath: "orgName",

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,
                        // tooltipTemplate: "REPLACE",
                        dataLabels: false,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "name",
                                dataPath: "values",
                                valuePath: "percent",
                         //       colors: ["grey", "magenta", "yellow", "red", "green", "purple", "orange", "blue1", "blue3"]
                            }
                        ],
                        errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: newEnrollmentByRace,
                        dataSourceName: "data",
                    }
                ]
            },
            {
                title: "New Awards by Gender",
                explanationText: 'This report shows the number and percent of graduates by gender at time of completion. "Unknown" means the student did not report their gender to the college. This data includes all public and private postsecondary institutions in Minnesota, including Walden University and Capella University (2 large private postsecondary institutions offering programs online and mainly enrolling non-Minnesota resident students in graduate-level programs).',
                openByDefault: false,
                views: [
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "collegeGraduatesByGender.data",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsAcrossRows",
                        convertDataHashToArray: true,
                        dataDimensions: 2,
                        xAxisLabelPath: "orgName",

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,
                        //  tooltipTemplate: "REPLACE",
                        dataLabels: false,

                        // SERIES
                        series: [

                            {
                                seriesDisplayNamePath: "[0].slice[0].name",
                                valuePath: "slice[0].percent",
                          //      color: "purple"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[1].name",
                                valuePath: "slice[1].percent",
                            //    color: "orange"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[2].name",
                                valuePath: "slice[2].percent",
                            //   color: "blue3"
                            }
                        ],
                        errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: newEnrollmentByGender,
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "New Awards by Age",
                explanationText: 'This report shows the number and percent of graduates by age at time of completion. "Unknown" means the student did not report their date of birth to the college. This data includes all public and private postsecondary institutions in Minnesota, including Walden University and Capella University (2 large private postsecondary institutions offering programs online and mainly enrolling non-Minnesota resident students in graduate-level programs).',
                openByDefault: false,
                views: [
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "stackedColumn",
                        dataSourceName: "data",
                        dataPath: "collegeGraduatesByAge.data",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsAcrossRows",
                        convertDataHashToArray: true,
                        dataDimensions: 2,
                        xAxisLabelPath: "orgName",

                        // DISPLAY
                        unitString: "%",
                        showLegend: true,
                        //    tooltipTemplate: "REPLACE",
                        dataLabels: false,

                        // SERIES
                        series: [
                            {
                                seriesDisplayNamePath: "[0].slice[0].name",
                                valuePath: "slice[0].percent",
                             //   color: "red"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[1].name",
                                valuePath: "slice[1].percent",
                             //   color: "green"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[2].name",
                                valuePath: "slice[2].percent",
                            //    color: "purple"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[3].name",
                                valuePath: "slice[3].percent",
                            //    color: "orange"
                            },
                            {
                                seriesDisplayNamePath: "[0].slice[4].name",
                                valuePath: "slice[4].percent",
                             //   color: "blue3"
                            }
                        ],
                        errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: newEnrollmentByAge,
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "Awards",
                explanationText: "This report shows the number and percent of graduate by type of award completed. This report excludes certificates in length shorter than 15 quarter credits, 10 semester credits, 350 clock hours or the equivalent, prior to 2016. This data includes all public and private postsecondary institutions in Minnesota, including Walden University and Capella University (2 large private postsecondary institutions offering programs online and mainly enrolling non-Minnesota resident students in graduate-level programs).",
                openByDefault: false,
                views: [
                    {
                        // SETUP
                        type: "pie",
                        dataSourceName: "data",
                        dataSetPath: "programOfStudy",
                        //dataPath: "dataSets.raceAndEthnicity.data", 
                        // all paths in the
                        // chartable series are
                        // relative to this blob

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        convertDataHashToArray: true,
                        dataDimensions: 1,
                        title: "",

                        // DISPLAY
                        unitString: "%",
                        unitDec: 0,

                        showLegend: true,
                        dataLabels: false,

                        // SERIES (only one series, this is a simple graph)
                        series: [{
                            valuePath: "percent",
                            displayNamePath: "award",
                            longDisplayNamePath: "award",
                        }],
                        errorConditions: [
                            {
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: programOfStudyTemplate,
                        dataSourceName: "data",
                    }
                ]
            },
            {
                title: "Top Ten Majors",
                explanationText: "This report shows the number of graduates by type of award and major for the 10 most frequent programs in descending order. This data includes all public and private postsecondary institutions in Minnesota, including Walden University and Capella University (2 large private postsecondary institutions offering programs online and mainly enrolling non-Minnesota resident students in graduate-level programs).",

                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: topTenMajorsTemplate,
                        dataSourceName: "data",
                           errorConditions: [
                            {
                                valuePath: "data.data.topTenMajors.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }
                        ]
                    }
                ]
            },
            {
                title: "More Information",
                visibleByDefault: true,
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<p><a href='' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>For more information on college degrees and awards conferred in Minnesota, please visit the  <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a> and the <a href='http://www.ohe.state.mn.us/mPg.cfm?pageID=1089'  target='_blank'>Office of Higher Education's Degrees, Graduation Rates, Attainment and Outcomes Data</a>.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031885&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all colleges or systems and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }
                ]
            }
        ],

        filterSources: {
            orgs: {
                modelType: SLEDSModels.SLEDSOrgList,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ps_orgid_completer.fex",
                noViewParams: true,
                enabled: true
            },
            filters: {
                modelType: CardboardModels.FilterData,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion_college.fex",
                enabled: true
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_collegegraduatescohortid.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            filters3: {
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_collegegraduatesaward.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            demographicCategories: {
                modelType: CardboardCollections.DemoCatProducer,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_newcollegeStudentGraduatesButtons.fex",
                enabled: true,
                noViewParams: false,
                isCat: true
            }
        },
        dataSources: {
            data: {
                modelType: CardboardModels.DocumentModel,
                // url: "/data/mocks/preGradData.json",
                // url: "/data/mocks/preGradData_statewide.json",
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_collegegraduates.fex",
                yearPath: "dataYear",
                defaultParams: {
                    orgId: 999999000,
                    collegeGraduatesCOHORTID: 2015
                },
                paramMappings: {
                    PS_ORGID: "orgId",
                    orgName: null, // skip this
                    collegeGraduatesCOHORTID: "dataYear"
                },
                enabled: true,

            }
        }
    };

    return exports;
});
